import { useCallback } from "react";
import { get, keyBy } from "lodash";
import { useLazyQuery } from "@apollo/client";
import { getDirectMembersAndChildTeamsQuery } from "src/queries/group.graphql";
import updateLoadedData from "../utils/updateLoadedData";

const useOrgChartDataLoader = ({ dispatch, state }) => {
  const [getDirectMembersAndChildTeams] = useLazyQuery(
    getDirectMembersAndChildTeamsQuery,
    { errorPolicy: "all", fetchPolicy: "cache-and-network" }
  );

  const loadChildTeamsById = useCallback(
    async (group, updateExpandedNodes = true) => {
      if (!group) {
        return;
      }

      const expandedNodes = updateExpandedNodes
        ? [...state.expandedNodes, group.id]
        : undefined;

      if (group.childTeams) {
        updateLoadedData(dispatch, {
          loadedTeams: keyBy(
            group.childTeams.map((g) => ({
              ...g,
              isLoading: true,
              ...get(state, `loadedTeams.${g.id}`, {}),
            })),
            "id"
          ),
          expandedNodes,
        });
      }

      const result = await getDirectMembersAndChildTeams({
        variables: { groupId: group.id },
      });

      updateLoadedData(dispatch, {
        loadedTeams: keyBy(
          result.data.team.childTeams.map((n) => ({
            ...n,
            isLoading: false,
          })),
          "id"
        ),
        loadedMembers: keyBy(result.data.team.members, "aggregateId"),
        expandedNodes,
      });
    },
    [getDirectMembersAndChildTeams, dispatch, state]
  );

  return {
    loadChildTeamsById,
  };
};

export default useOrgChartDataLoader;
